<!-- 2 columns form -->
<form #customerForm="ngForm" name="customerForm">
  <div class="panel panel-flat">
    <div class="panel-heading">
      <h5 class="panel-title">Add Customer</h5>
      <div class="heading-elements">
        <ul class="icons-list">
          <li>
            <a data-action="reload" ng-click="mainService.reload()"></a>
          </li>
        </ul>
      </div>
      <hr class="divider">
    </div>

    <div class="panel-body">

      <div class="row">
        <div class="col-md-7">
          <fieldset>

            <div class="row">
              <div class="col-md-4"></div>
              <div class="col-md-4">
                <div class="thumb thumb-rounded">
                  <img *ngIf="!customer?.user?.data?.avatar" src="assets/img/userm.png" alt="">
                  <img *ngIf="customer?.user?.data?.avatar"
                    [src]="baseUrl+'assets/'+customer?.user?.data?.avatar+'/render'" alt="Profile Imag"
                    class="profileImg img-responsive">
                  <input type="file" (change)="fileChange($event, 'avatar')"
                    style="opacity: 0.0; position: absolute;top:0;left: 0;bottom: 0;right:0; width: 100%; height: 100%;">
                </div>
              </div>
              <div class="col-md-4"></div>

              <!--  <div class="col-md-12">
                <div class="">
                  <div class="thumb thumb-rounded text-center">
                    <img *ngIf="!customer?.user?.data?.avatar" src="assets/img/userm.png" width="10" height="10"
                      class="img-circle img-xl" alt="">
                  </div>
                </div>
              </div> -->
            </div><br>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group required"
                  [ngClass]="{'has-error':(nameControl.touched && nameControl.invalid) || (nameControl.invalid && formHasError)}">
                  <span class="control-label"> Full Name: </span>
                  <input type="text" name="name" required [(ngModel)]="customer.full_name" #nameControl="ngModel"
                    class="form-control" placeholder="Enter customer full name">
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required"
                  [ngClass]="{'has-error':(genderControl.touched && genderControl.invalid) || (genderControl.invalid && formHasError)}">
                  <span class="control-label">Gender: </span>
                  <select name="status" required [(ngModel)]="customer.gender" #genderControl="ngModel"
                    class="form-control" data-placeholder="Gender">
                    <option>Gender:</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required"
                  [ngClass]="{'has-error':(idControl.touched && idControl.invalid) || (idControl.invalid && formHasError)}">
                  <span class="control-label"> Id/Passport Number: </span>
                  <input type="text" name="id" required [(ngModel)]="customer.id_passport_number" #idControl="ngModel"
                    class="form-control" placeholder="Enter customer Id or passport number">
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required"
                  [ngClass]="{'has-error': (emailControl.touched && emailControl.invalid) || (emailControl.invalid && formHasError)}">
                  <span class="control-label"> Email Address: </span>
                  <input type="text" name="email" required [(ngModel)]="customer.email" #emailControl="ngModel"
                    class="form-control" placeholder="user email address">
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required"
                  [ngClass]="{'has-error': (phoneControl.touched && phoneControl.invalid) || (phoneControl.invalid && formHasError)}">
                  <span class="control-label"> Priamry Phone Number: </span>
                  <input type="text" name="phone" required [(ngModel)]="customer.phone_number_1" #phoneControl="ngModel"
                    class="form-control" placeholder="customer primary phone number">
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required"
                  [ngClass]="{'has-error': (phoneControl.touched && phoneControl.invalid) || (phoneControl.invalid && formHasError)}">
                  <span class="control-label"> Secondary Phone Number: </span>
                  <input type="text" name="phone2" [(ngModel)]="customer.phone_number_2" #phoneControl="ngModel"
                    class="form-control" placeholder="customer secondary phone number">
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required"
                  [ngClass]="{'has-error':(regionControl.touched && regionControl.invalid) || (regionControl.invalid && formHasError) || !match}">
                  <span class="control-label"> Region: </span>
                  <select name="status" required [(ngModel)]="customer.region" #regionControl="ngModel"
                    class="form-control" data-placeholder="Region">
                    <option selected disabled>Region:</option>
                    <option *ngFor="let region of regions" value="{{region.value}}">{{region.name}}</option>
                  </select>
                  <!-- <input type="text" name="region" required [(ngModel)]="customer.region" #regionControl="ngModel"
                  class="form-control" placeholder="Customer residence region"> -->
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required"
                  [ngClass]="{'has-error':(cityControl.touched && cityControl.invalid) || (cityControl.invalid && formHasError) || !match}">
                  <span class="control-label"> City: </span>
                  <input type="text" name="city" required [(ngModel)]="customer.city" #cityControl="ngModel"
                    class="form-control" placeholder="Customer residence city">
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required"
                  [ngClass]="{'has-error':(subcityControl.touched && subcityControl.invalid) || (subcityControl.invalid && formHasError) || !match}">
                  <span class="control-label">Sub Ctity: </span>
                  <input type="text" name="subCity" required [(ngModel)]="customer.sub_city" #subcityControl="ngModel"
                    class="form-control" placeholder="Customer residence sub city">
                </div>
              </div>

            </div>

            <div class="row">

              <div class="col-md-4">
                <div class="form-group required"
                  [ngClass]="{'has-error':(woredaControl.touched && woredaControl.invalid) || (woredaControl.invalid && formHasError) || !match}">
                  <span class="control-label">Woreda/Kebele: </span>
                  <input type="text" name="woreda" [(ngModel)]="customer.woreda_kebele" #woredaControl="ngModel"
                    class="form-control" placeholder="Customer Woreda or kebele">
                </div>
              </div>



              <div class="col-md-4">
                <div class="form-group required"
                  [ngClass]="{'has-error':(houseNumber.touched && houseNumber.invalid) || (houseNumber.invalid && formHasError) || !match}">
                  <span class="control-label">House Number: </span>
                  <input type="text" name="houseNumber" required [(ngModel)]="customer.house_no" #houseNumber="ngModel"
                    class="form-control" placeholder="Customer house number">
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required"
                  [ngClass]="{'has-error':(emergencyContact.touched && emergencyContact.invalid) || (emergencyContact.invalid && formHasError) || !match}">
                  <span class="control-label">Emergency Contact: </span>
                  <input type="text" name="emergencyContact" required [(ngModel)]="customer.emergency_contact"
                    #emergencyContact="ngModel" class="form-control" placeholder="Customer emergency contact">
                </div>
              </div>

              <div class="col-md-4">
                <div class="form-group required"
                  [ngClass]="{'has-error':(emergencyPhone.touched && emergencyPhone.invalid) || (emergencyPhone.invalid && formHasError) || !match}">
                  <span class="control-label">Emergency Phone: </span>
                  <input type="text" name="emergencyPhone" required [(ngModel)]="customer.emergency_phone"
                    #emergencyPhone="ngModel" class="form-control" placeholder="Emergency contact person phone">
                </div>
              </div>
            </div>

          </fieldset>
        </div>

        <div class="col-md-1"></div>
        <div class="col-md-4">

          <h6>Id Front</h6>
          <hr>
          <div class="well" style="min-height: 250px;">
            <input type="file" name="id_front" id="id_front" (change)="fileChange($event, 'id_front')"
              style="opacity: 0.0; position: absolute;top:0;left: 0;bottom: 0;right:0; width: 100%; height: 100%;">
            <img [src]="baseUrl+'assets/'+customer?.user?.data?.id_front+'/render'" alt="ID Front"
              class="profileImg img-responsive">
          </div>


          <h6>Id Back</h6>
          <hr>
          <div class="well" style="min-height: 250px;">
            <input type="file" name="id_back" id="id_back" (change)="fileChange($event, 'id_back')"
              style="opacity: 0.0; position: absolute;top:0;left: 0;bottom: 0;right:0; width: 100%; height: 100%;">
            <img [src]="baseUrl+'assets/'+customer?.user?.data?.id_back+'/render'" alt="ID Back"
              class="profileImg img-responsive">

          </div>
          <br>

        </div>

        <div class="text-right">
          <button class="btn bg-slate-800" (click)="addCustomer(customer.id)" type="submit" data-style="slide-right"
            [ladda]="isLoading" [disabled]="customerForm.invalid">
            <span *ngIf="!customer.id">Save Customer</span>
            <span *ngIf="customer.id">Update Customer</span>
            <i class="icon-floppy-disk position-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</form>
<!-- /2 columns form -->